<div [attr.class]="'booking-heading ' + (classList ? 'booking-heading--' + classList : '')">
  <ng-container *ngIf="isShowImage">
    <!--The picture might be cached by lazysize when it doesn't detect a change in the src attribute
      That can happen when the booking widget is loaded first with no data. Fix: check if the _name exists
      -->
    <div [attr.class]="'booking-heading__img ' + (classList ? 'booking-heading__img--' + classList : '')">
      <ng-container *ngIf="bwImages?.length === 1">
        <img
          appImageFallback
          class="responsive-img"
          alt=""
          src="{{ (dataFetched ? bwImages[0].url : imagePlaceholder) + '?w=425&h=280&fit=crop&auto=format' }}"
        />
      </ng-container>
      <ng-container *ngIf="bwImages?.length > 2">
        <div class="booking-heading__images">
          <div class="booking-heading__images-left">
            <div class="booking-heading__img-top">
              <img
                appImageFallback
                class="responsive-img booking-heading__img"
                alt=""
                src="{{ (dataFetched ? bwImages[0].url : imagePlaceholder) + '?w=210&h=98&fit=crop&auto=format' }}"
              />
            </div>
            <div class="booking-heading__img-bottom">
              <img
                appImageFallback
                class="responsive-img booking-heading__img"
                alt=""
                src="{{ (dataFetched ? bwImages[1].url : imagePlaceholder) + '?w=210&h=98&fit=crop&auto=format' }}"
              />
            </div>
          </div>
          <div class="booking-heading__images-right">
            <div class="booking-heading__img-full">
              <img
                appImageFallback
                class="responsive-img booking-heading__img"
                alt=""
                src="{{ (dataFetched ? bwImages[2].url : imagePlaceholder) + '?w=210&h=200&fit=crop&auto=format' }}"
              />
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div
    [attr.class]="'booking-heading__caption ' + (classList ? 'booking-heading__caption--' + classList : '')"
    [ngClass]="{ 'booking-heading__caption--opened': !hiddenContent }"
    (click)="openDetails()"
  >
    <ng-container *ngIf="dataFetched">
      <h6
        class="booking-heading__caption-title"
        [ngClass]="classList ? 'booking-heading__caption-title--' + classList : ''"
      >
        {{ name }}
      </h6>
      <p
        class="booking-heading__caption-place"
        [ngClass]="classList ? 'booking-heading__caption-place--' + classList : ''"
      >
        <i class="fa-light fa-location-dot booking-heading__location-icon"></i> {{ streetAddress }}
      </p>
    </ng-container>

    <ng-container *ngIf="!dataFetched">
      <div class="placeholder-text placeholder-text--title"></div>
      <div class="placeholder-text placeholder-text--place"></div>
    </ng-container>
  </div>
</div>
